import "./BookService.module.css";
import Header from "@/reusable_sections/Header";
import ServiceBookingCalendar from "./sections/ServiceBookingCalendar";
import Contact from "./sections/Contact";
import ContactInquiry from "./sections/ContactInquiry";
import Footer from "@/reusable_sections/Footer";
export default function BookServicePage() {
  return <div>
      <Header />
      <ServiceBookingCalendar />
      <Contact />
      <ContactInquiry />
      <Footer />
    </div>;
}